// extracted by mini-css-extract-plugin
export default {"contenedorPrincipal":"ContenidoInterno_contenedorPrincipal__QjUft"};